// TODO remove jQuery
import $ from 'jquery/dist/jquery.min';
// import 'bootstrap3';

window.jQuery = $;
window.$ = $;
// -------------------
